import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["text", "showIcon", "hiddenIcon", "hiddenContent"]
    static values = {
        "hiddenClass": String,
        "showClass": String,
        "triggerHiddenText": String,
        "triggerShowText": String
    }

    connect() {
        this.hiddenClassValues = this.hiddenClassValue.split(" ")
        this.showClassValues = this.showClassValue.split(" ")
    }

    toggle(_e) {
        const isHidden = this.hiddenClassValues.map(v => this.hiddenContentTarget.classList.contains(v))
            .reduce((acc, el) => el && acc, true)

        if (isHidden) {
            this.hiddenClassValues.forEach(v => {
                this.hiddenContentTarget.classList.remove(v)
            })
            this.showClassValues.forEach(v => {
                this.hiddenContentTarget.classList.add(v)
            })
            this.textTarget.textContent = this.triggerHiddenTextValue
        } else {
            this.hiddenClassValues.forEach(v => {
                this.hiddenContentTarget.classList.add(v)
            })
            this.showClassValues.forEach(v => {
                this.hiddenContentTarget.classList.remove(v)
            })
            this.textTarget.textContent = this.triggerShowTextValue
        }

        if (this.hasShowIconTarget) this.showIconTarget.classList.toggle("hidden")
        if (this.hasHiddenIconTarget) this.hiddenIconTarget.classList.toggle("hidden")
    }
}